import { Link } from 'react-router-dom';
import './Navbar.css'
import Searchbar from './Searchbar';

const NavBar = () => {


    const changeTheme = () => {
        if(document.documentElement.classList.contains('dark')) {
            document.getElementById('change_theme_moon').classList.remove('hidden');
            document.getElementById('change_theme_sun').classList.add('hidden');
            document.documentElement.classList.remove('dark');
        } else {
            document.getElementById('change_theme_sun').classList.remove('hidden');
            document.getElementById('change_theme_moon').classList.add('hidden');
            document.documentElement.classList.add('dark')
        }
    }

    const showSideBar = () => {
        let sidebar = document.getElementById('sidebar');
        if(sidebar.classList.contains('show')){
            sidebar.classList.remove('show');
        }
        else{
            sidebar.classList.add('show');
        }
    }


    return(
        <nav className="navbar sticky top-0 z-[99] bg-white dark:bg-dark-nav-bg shadow-[0px_8px_8px_rgba(0,0,0,0.15)] py-3 px-5">
            <div className="flex items-center justify-between">

                <div className='flex justify-center items-center'>
                    <button onClick={showSideBar} className = 'h-[25px] w-[25px] mr-5 mb-[5px] hover:opacity-75 lg:hidden dark:text-white' id = 'sidebar_menu_btn'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill = 'currentColor' viewBox="0 0 448 512" id = 'sidebar_menu_btn_svg'>
                            <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"/>
                        </svg>
                    </button>
                    <Link to = '/' className="absolute z-[1000] left-[60px] md:static navbar-brand w-[140px]">
                        <img alt='logo' src={require('../../assets/images/logo_green.png')} className = "w-full " />
                        {/* <img alt='logo' src={require('../../assets/images/logo_white.png')} className = "w-full hidden dark:block" /> */}
                    </Link>
                </div>

                <div className="flex-grow">
                    {/* Searchbar */}
                    <Searchbar />
                </div>

                <div className="flex items-center dark:text-[#F6F6F6]">

                    <Link to = '/collections' className='mr-[1rem] font-[500] hidden lg:block'>
                        Collections
                    </Link>

                    <Link to = '/activity' className='mr-[1rem] font-[500] hidden lg:block'>
                        Activity
                    </Link>

                    <Link to = '/rankings' className='mr-[1rem] font-[500] hidden lg:block'>
                        Rankings
                    </Link>

                    <div className="dropdown relative hidden lg:block mr-[1rem]">
                        <button className="font-[500] inline-flex items-center" id = "dropdown_button_2" mode = "more" >
                            <span className="">Creator</span>
                            <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/> </svg>
                        </button>
                        <ul className="dropdown-menu absolute hidden w-[230px] border-2 border-gray-300 z-10" id = "nav_dropdown_2">
                            <li className="">
                                <a href = 'http://airtable.com/' rel="noreferrer" target = "__blank" className="rounded-t text-[16px] nav_link border-b-[1px] border-gray-400 bg-white dark:bg-black py-4 px-5 block whitespace-no-wrap">Apply for Listing</a>
                            </li>
                            <li className="">
                                <a href = 'http://airtable.com/' rel="noreferrer" target= "__blank" className="rounded-b bg-white dark:bg-black text-[16px] nav_link  py-4 px-5 block whitespace-no-wrap">Apply for Launchpad</a>
                            </li>
                        </ul>
                    </div>

                    <Link to = '/member/:id' className='mr-[1rem] font-[500] hidden lg:block'>
                        Profile
                    </Link>


                    <Link to = '/connectwallet' className='text-black dark:text-white w-[25px] h-[25px] font-[500] hidden lg:block'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill = 'currentColor' viewBox="0 0 512 512">
                            <path d="M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"/>
                        </svg>
                    </Link>

                    <button className='hidden w-[25px] h-[25px] text-[#ffff3f] ml-3 lg:mb-[2px]' id = 'change_theme_sun' onClick={changeTheme}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill='currentColor' viewBox="0 0 512 512">
                            <path d="M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z"/>
                        </svg>
                    </button>

                    <button className='w-[25px] h-[25px] text-[#0e3862] ml-3 lg:mb-[2px]' id = 'change_theme_moon' onClick={changeTheme}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill='currentColor' viewBox="0 0 512 512">
                            <path d="M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"/>
                        </svg>
                    </button>

                </div>

            </div>

        </nav>
    )
}

export default NavBar;